"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var component_1 = require("../component");
var circos = require("../component/circos");
var element_1 = require("../element");
var layout_1 = require("../layout");
var log_1 = require("../log");
var global_1 = require("../global");
var geometry_1 = require("../geometry");
var logger = log_1.getLogger("composition");
exports.elementNames = {
    Arc: element_1.Arc,
    ArcLine: element_1.ArcLine,
    Area: element_1.Area,
    AreaChart: component_1.AreaChart,
    Axis: component_1.Axis,
    AxisWithBackground: component_1.AxisWithBackground,
    BarChart: component_1.BarChart,
    BarChartGrouped: component_1.BarChartGrouped,
    BaseSlopeChart: component_1.BaseSlopeChart,
    BoxPlot: component_1.BoxPlot,
    BulletChart: component_1.BulletChart,
    BumpChart: component_1.BumpChart,
    Canvas: component_1.Canvas,
    Chord: component_1.Chord,
    Chromosome: component_1.Chromosome,
    Circle: element_1.Circle,
    CirclePacking: component_1.CirclePacking,
    Component: component_1.Component,
    ConnectedDotChart: component_1.ConnectedDotChart,
    DotChart: component_1.DotChart,
    ForceDirect: component_1.ForceDirect,
    Gene: component_1.Gene,
    GeneArea: component_1.GeneArea,
    HorizonChart: component_1.HorizonChart,
    Layout: component_1.Layout,
    LayoutItem: layout_1.LayoutItem,
    Line: element_1.Line,
    LineChart: component_1.LineChart,
    LinearLayout: layout_1.LinearLayout,
    Map: component_1.Map,
    ParallelChart: component_1.ParallelChart,
    Partition: component_1.Partition,
    Path: element_1.Path,
    PieChart: component_1.PieChart,
    PolarChart: component_1.PolarChart,
    Proxy: component_1.Proxy,
    RadarChart: component_1.RadarChart,
    RadicalLine: element_1.RadicalLine,
    RangeChart: component_1.RangeChart,
    Rect: element_1.Rect,
    RectangleChart: component_1.RectangleChart,
    Ribbon: element_1.Ribbon,
    SankeyChart: component_1.SankeyChart,
    SimpleArea: element_1.SimpleArea,
    SlopeChart: component_1.SlopeChart,
    Sunburst: component_1.Sunburst,
    Text: element_1.Text,
    Treemap: component_1.Treemap,
    Venn: component_1.Venn,
    WaterfallChart: component_1.WaterfallChart,
    circos: circos,
};
function combine() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var comp = new component_1.Component();
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var option = args_1[_a];
        var typeName = option._type;
        if (typeof typeName !== "string") {
            console.error("No _type definition!");
            return null;
        }
        var type = exports.elementNames[typeName];
        if (!type) {
            console.error("Undefined _type name " + typeName + "!");
            return null;
        }
        comp.appendT(type).options(option);
    }
    return comp;
}
exports.combine = combine;
function instantiate(option) {
    var _a;
    var ctor;
    if (typeof option._type === "string") {
        ctor = findComponent(option._type);
    }
    else if (typeof option._type === "function") {
        ctor = option._type;
    }
    else {
        throw new Error("No _type definition for current object");
    }
    var element = new ctor();
    if (option.__args__ && option.__args__.length > 0) {
        (_a = ctor.initializeFromTemplate).call.apply(_a, __spreadArrays([element, option], option.__args__));
    }
    if (option._autoSize) {
        element.hasFixedSize = false;
        element.options({
            _width: geometry_1.GeometryValue.auto,
            _height: geometry_1.GeometryValue.auto,
        });
    }
    else if (option._absPos && element instanceof element_1.BaseElement) {
        element.hasAbsolutePosition = true;
    }
    element.options(option);
    element.$visualizer = global_1.default.currentVisualizer;
    if (element instanceof component_1.Component && option._children) {
        var children = option._children;
        for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var subOpt = children_1[_i];
            element._append(instantiate(subOpt), subOpt._isGroup);
        }
    }
    else if (element.isLayout && option._children) {
        var children = option._children;
        for (var _b = 0, children_2 = children; _b < children_2.length; _b++) {
            var subOpt = children_2[_b];
            if (subOpt._type !== "LayoutItem") {
                logger.error("Children of a Layout must be LayoutItem");
                return;
            }
            element.append(instantiate(subOpt));
        }
    }
    if (option._outlet) {
        var outlet = option._outlet;
        if (typeof outlet === "string") {
            global_1.default.currentVisualizer.outlets[outlet] = element;
        }
        else {
            outlet.obj[outlet.attr] = element;
        }
    }
    return element;
}
exports.instantiate = instantiate;
function findComponent(typeName) {
    var typeObject;
    var path = typeName.split(":");
    typeObject = _.get(exports.elementNames, path);
    if (!typeObject) {
        typeObject = _.get(global_1.default.currentVisualizer.exElementList, path);
    }
    if (!typeObject) {
        throw new Error("Undefined _type name " + typeName);
    }
    return typeObject;
}
//# sourceMappingURL=instantiate.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/template/instantiate.js
// module id = 383
// module chunks = 0 1